
import { createContext, useContext, useRef, type ReactNode } from 'react';
import { RootStore } from './RootStore';

const StoreContext = createContext<RootStore | null>(null);

export function StoreProvider({ children }: { children: ReactNode }) {
  const storeRef = useRef<RootStore | null>(null);
  if (!storeRef.current) {
    storeRef.current = new RootStore();
  }
  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  );
}

export function useStore(): RootStore {
  const store = useContext(StoreContext);
  if (!store) throw new Error('useStore must be used within StoreProvider');
  return store;
}

export function useContactStore() { return useStore().contactStore; }
export function useDealStore() { return useStore().dealStore; }
export function useDealTypeStore() { return useStore().dealTypeStore; }
export function useProjectStore() { return useStore().projectStore; }
export function useTaskStore() { return useStore().taskStore; }
export function useNoteStore() { return useStore().noteStore; }
export function useNoteAttachmentStore() { return useStore().noteAttachmentStore; }
export function useAuditLogStore() { return useStore().auditLogStore; }
export function useUserStore() { return useStore().userStore; }
export function useSyncStore() { return useStore().syncStore; }
